<template>
  <svg class="tooth">
    <g :transform="`translate(${positionX + 2.5}, ${positionY - 5})`" >
      <!-- Primer rectángulo -->
      <!-- <rect
        width="8"
        height="8"
        x="0"
        y="0"
        stroke="navy"
        fill="white"
        stroke-width="0.5"
      />
      <text
        x="3.75"
        y="5"
        text-anchor="middle"
        dominant-baseline="middle"
        font-size="4"
        fill="black"
      >
        EM
      </text>

   
      <rect
        width="8"
        height="8"
        x="9.5"
        y="0"
        stroke="navy"
        fill="white"
        stroke-width="0.5"
      />
      <text
        x="13.25"
        y="5"
        text-anchor="middle"
        dominant-baseline="middle"
        font-size="4"
        fill="black"
      >
        RX
      </text> -->

      <!-- Tercer rectángulo -->
      <rect
        width="18.5"
        height="8"
        x="0"
        y="9.5"
        stroke="navy"
        fill="white"
        stroke-width="0.5"
        :class="getClassNamesByZone('cuello')"
        @click="openContextMenu($event, 'cuello')"
       
      />
      <text
        x="8.75"
        y="13"
        text-anchor="middle"
        dominant-baseline="middle"
        font-size="4"
        fill="black"
      >
        CUELLO
      </text>
    </g>

    <g :transform="translate">
      <polygon
        points="0,0 20,0 15,5 5,5"
        :class="getClassNamesByZone('arriba')"
        @click="openContextMenu($event, 'arriba')"
      />
      <polygon
        points="5,15 15,15 20,20 0,20"
        :class="getClassNamesByZone('abajo')"
        @click="openContextMenu($event, 'abajo')"
      />
      <polygon
        points="15,5 20,0 20,20 15,15"
        :class="getClassNamesByZone('derecha')"
        @click="openContextMenu($event, 'derecha')"
      />
      <polygon
        points="0,0 5,5 5,15 0,20"
        :class="getClassNamesByZone('izquierda')"
        @click="openContextMenu($event, 'izquierda')"
      />
      <polygon
        points="5,5 15,5 15,15 5,15"
        :class="getClassNamesByZone('centro')"
        @click="openContextMenu($event, 'centro')"
      />
      <text
        x="6"
        y="30"
        stroke="navy"
        fill="navy"
        stroke-width="0.1"
        class="tooth"
      >
        {{ number }}
      </text>
      <g
        v-if="
          dataDientesFromStore.zonaProcedimiento &&
          dataDientesFromStore.zonaProcedimiento.all &&
          dataDientesFromStore.zonaProcedimiento.all.procedimiento === 'ext'
        "
        :stroke="
          dataDientesFromStore.zonaProcedimiento &&
          dataDientesFromStore.zonaProcedimiento.all &&
          dataDientesFromStore.zonaProcedimiento.all.encontrado || dataDientesFromStore.zonaProcedimiento.all.realizado
            ? 'blue'
            : 'red'
        "
        @click="openContextMenu($event, 'all')"
      >
        <line x1="0" y1="0" x2="20" y2="20" stroke-width="2" />
        <line x1="0" y1="20" x2="20" y2="0" stroke-width="2" />
      </g>
      <g
        v-if="
          dataDientesFromStore.zonaProcedimiento &&
          dataDientesFromStore.zonaProcedimiento.all &&
          dataDientesFromStore.zonaProcedimiento.all.procedimiento === 'end'
        "
        :stroke="
          dataDientesFromStore.zonaProcedimiento &&
          dataDientesFromStore.zonaProcedimiento.all &&
          dataDientesFromStore.zonaProcedimiento.all.encontrado || dataDientesFromStore.zonaProcedimiento.all.realizado
            ? 'blue'
            : 'red'
        "
        @click="openContextMenu($event, 'all')"
      >
        <line x1="0" y1="20" x2="10" y2="0" stroke-width="2" />
        <line x1="20" y1="20" x2="10" y2="0" stroke-width="2" />
        <line x1="0" y1="20" x2="20" y2="20" stroke-width="2" />
      </g>

      <g
        v-if="toothStateFromStore.Fracture > 0"
        :stroke="toothStateFromStore.Fracture === 1 ? 'red' : 'blue'"
      >
        <line x1="0" y1="10" x2="20" y2="10" stroke-width="2" />
      </g>

      <g
        v-if="
          dataDientesFromStore.zonaProcedimiento &&
          dataDientesFromStore.zonaProcedimiento.all &&
          dataDientesFromStore.zonaProcedimiento.all.procedimiento ===
            'sellante'
        "
        :stroke="
          dataDientesFromStore.zonaProcedimiento &&
          dataDientesFromStore.zonaProcedimiento.all &&
          dataDientesFromStore.zonaProcedimiento.all.encontrado || dataDientesFromStore.zonaProcedimiento.all.realizado
            ? 'blue'
            : 'red'
        "
        @click="openContextMenu($event, 'all')"
      >
        <!-- Línea vertical -->
        <line x1="10" y1="0" x2="10" y2="20" stroke-width="2" />

        <!-- Diagonal ↘ -->
        <line x1="0" y1="0" x2="20" y2="20" stroke-width="2" />

        <!-- Diagonal ↙ -->
        <line x1="0" y1="20" x2="20" y2="0" stroke-width="2" />
      </g>

      <g
        v-if="
          dataDientesFromStore.zonaProcedimiento &&
          dataDientesFromStore.zonaProcedimiento.all &&
          dataDientesFromStore.zonaProcedimiento.all.procedimiento === 'cop'
        "
        :stroke="
          dataDientesFromStore.zonaProcedimiento &&
          dataDientesFromStore.zonaProcedimiento.all &&
          dataDientesFromStore.zonaProcedimiento.all.encontrado || dataDientesFromStore.zonaProcedimiento.all.realizado
            ? 'blue'
            : 'red'
        "
        @click="openContextMenu($event, 'all')"
      >
        <!-- Cuadrado externo -->
        <rect x="0" y="0" width="20" height="20" stroke-width="1" />

        <!-- Cuadrado medio -->
        <rect x="4" y="4" width="12" height="12" stroke-width="1" />

        <!-- Cuadrado interno pequeño -->
        <rect x="7" y="7" width="6" height="6" stroke-width="1" />
      </g>
    </g>
    <g :transform="`translate(${positionX + 25}, ${positionY + 20})`">
      <circle
        @click="openContextMenu($event, 'supernumerario')"
        r="4.5"
        cx="1"
        cy="10"
        fill="white"
        stroke="black"
        stroke-width="0.5"
      />
    </g>
  </svg>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "Tooth",
  props: {
    number: Number,
    positionX: Number,
    positionY: Number,
    tipoProcedimientoSelected: {
      default: null,
      required: true,
    },
    procedimientoSelected: {
      default: null,
      required: false,
    },
  },

  data() {
    return {
      menuVisible: false,
      currentZone: null,
      contextMenuStyle: {},
      firstUpdate: true,
      dienteActual: null,
    };
  },
  computed: {
     ...mapState({
    dataDientesFromStore(state) {
      return (
        state.odontologia.dataDientes.find(
          (t) => t.numeroPieza === this.number
        ) || {
          zona: null,
          numeroPieza: this.number,
          procedimiento: null,
          encontrado: null,
          realizado: null,
          token: null,
          zonaProcedimiento: {}, // <-- Esto es clave
        }
      );
    }
  }),
    isRoundedTooth() {
      return this.number >= 55 && this.number <= 75;
    },
    translate() {
      return `translate(${this.positionX},${this.positionY + 20})`;
    },

    toothStateFromStore() {
      return (
        this.$store.state.odontologia.toothStates.find(
          (t) => t.id === this.number
        ) || {}
      );
    },
    // dataDientesFromStore() {
    //   return (
    //     this.$store.state.odontologia.dataDientes.find(
    //       (t) => t.numeroPieza === this.number
    //     ) || {
    //       zona: null,
    //       numeroPieza: this.number,
    //       procedimiento: null,
    //       encontrado: null,
    //       realizado: null,
    //       token: null,
    //       zonaProcedimiento: {}, // <-- Esto es clave
    //     }
    //   );
    // },
  },

  watch: {
    dienteActual: {
      handler(newVal) {
        if (newVal) {
          console.log("🚀 Emitiendo dienteActual al padre:", newVal);

          // Emitir el evento hacia el padre
          this.$emit("diente-seleccionado", newVal);

          // Limpiar luego de emitir, usando $nextTick para no interrumpir el ciclo de render
          this.$nextTick(() => {
            this.dienteActual = null;
          });
        }
      },
      immediate: true, // No queremos que se dispare al inicio
      deep: true, // No hace falta deep si asignas objeto nuevo
    },
  },

  methods: {
    generarToken(diente, zona) {
      const timestamp = Date.now();
      const random = Math.floor(Math.random() * 100000);
      return `${diente}_${zona}_${timestamp}_${random}`;
    },
    enviarSupernumerario() {
      let dataTooth = {
        number: "supernumerario",
        zone: "-",
      };
    },
    // getClassNamesByZone(zone) {
    //   const state = this.toothStateFromStore.Cavities?.[zone];
    //   if (state === 1) return 'to-do';
    //   if (state === 2) return 'done';
    //   if (state === 4) return 'done-other';

    //   return '';
    // },
    getClassNamesByZone(zone) {
      const state = this.dataDientesFromStore.zonaProcedimiento?.[zone];
      let classy = "";

      if (!state) return classy; // No hay info para esa zona

      if (state.procedimiento === "caz") {
        classy = state.realizado || state.fecha_realizacion ? "done" : "to-do";
      }

       if (state.realizado || state.fecha_realizacion) {
        classy =  "done";
      }
      if (
        state.encontrado &&
        (state.procedimiento === "restauracion" ||
          state.procedimiento === "caz")
      ) {
        classy = "done-other";
      }

      return classy;
    },

    async openContextMenu(event, zone) {
      let diente = this.number;

      const encontrado = this.tipoProcedimientoSelected !== "1";

      const zonas = [
        "arriba",
        "abajo",
        "centro",
        "izquierda",
        "derecha",
        "all",
        "cuello"
      ];
      const zonaProcedimiento = {};

      const esZonaRealizada = (z) => {
        const zona = this.dataDientesFromStore.zonaProcedimiento?.[z];
        return zona?.encontrado && zona?.fecha_realizacion;
      };

      // 1. Verificar si alguna zona está realizada
      const algunaZonaRealizada = zonas.some((z) => esZonaRealizada(z));

      // Procedimientos que afectan toda la pieza
      const procsAllPieza = ["ext", "cop", "sellante", "end"];
      const cariesAllPieza = "cap";

      // Si alguna zona está realizada, no se puede modificar nada
      if (algunaZonaRealizada) {
        // Solo permitir "toggle" si se selecciona el mismo procedimiento en la misma zona que no está encontrado (pero como ya hay una realizada en otra zona, bloqueamos todo)
        // Por simplicidad, bloqueamos todo el procedimiento si existe algún encontrado
        return;
      }

      // Si no hay ningún procedimiento encontrado, continuar con la lógica normal

      // Procedimientos para toda la pieza (all)
      if (procsAllPieza.includes(this.procedimientoSelected)) {
        const zona = this.dataDientesFromStore.zonaProcedimiento?.["all"];
        const yaExisteProc = zona?.procedimiento === this.procedimientoSelected;

        zonas.forEach((z) => {
          zonaProcedimiento[z] = yaExisteProc
            ? null // eliminar si ya existe (toggle)
            : z === "all"
            ? {
                selected: true,
                procedimiento: this.procedimientoSelected,
                encontrado: encontrado,
                token: this.generarToken(diente, z),
              }
            : null;
        });
      }
      // Procedimiento que aplica CAZ a toda la pieza (cap)
      else if (this.procedimientoSelected === cariesAllPieza) {
        zonas.forEach((z) => {
          zonaProcedimiento[z] = {
            selected: true,
            procedimiento: "caz",
            encontrado: encontrado,
            token: this.generarToken(diente, z),
          };
        });
      }
      // Procedimientos por zona específica (caz, restauracion, etc.)
      else {
        zonas.forEach((z) => {
          const zona = this.dataDientesFromStore.zonaProcedimiento?.[z];

          if (z === zone) {
            const procedimientoActual = zona?.procedimiento;

            const yaExisteCaz =
              this.procedimientoSelected === "caz" &&
              procedimientoActual === "caz";
            const yaExisteRestauracion =
              this.procedimientoSelected === "restauracion" &&
              procedimientoActual === "restauracion";

            if (yaExisteCaz || yaExisteRestauracion) {
              zonaProcedimiento[z] = null; // eliminar si ya existe y no está encontrado (pero ya bloqueamos arriba que no hay encontrados)
            } else {
              zonaProcedimiento[z] = {
                selected: true,
                procedimiento: this.procedimientoSelected,
                encontrado: encontrado,
                token: this.generarToken(diente, z),
              };
            }

            zonaProcedimiento["all"] = null; // limpiar 'all' si es por zonas
          } else if (
            this.procedimientoSelected !== "caz" &&
            this.procedimientoSelected !== "restauracion"
          ) {
            zonaProcedimiento[z] = null;
          }
        });
      }

      // Guardamos la selección actual
      this.dienteActual = {
        zonaProcedimiento,
        numeroPieza: diente,
      };

      // Emitimos evento al componente padre
      this.$emit("diente-seleccionado", this.dienteActual);

      // Guardamos en el store como referencia
      this.$store.commit("setDataTooth", {
        number: diente,
        zone: zone,
        token: this.generarToken(diente, zone),
      });
    },
  },
};
</script>

<style scoped>
@import "./Tooth.css";
/* @import 'contextmenu/ContextMenu.css';*/

.context-menu {
  background-color: white;
  border: 1px solid #ccc;
  font-size: 14px;
  position: fixed;
  padding: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.context-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.context-menu li {
  padding: 4px 10px;
  cursor: pointer;
}

.context-menu li:hover {
  background-color: #eee;
}

.context-menu .separator {
  border-top: 1px solid #ddd;
  margin: 4px 0;
}
</style>
